"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const SvgComponent = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 64,
  height: 64,
  fill: "none",
  role: "img"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#BusbudPanel_svg__clip0)"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.6 6.58c3.64-3.63 5.46-5.45 7.56-6.13a9.2 9.2 0 015.68 0c2.1.68 3.92 2.5 7.56 6.13l15 14.99c3.65 3.63 5.47 5.45 6.15 7.54.6 1.85.6 3.83 0 5.68-.68 2.1-2.5 3.91-6.14 7.55L42.4 57.32c-3.64 3.63-5.46 5.45-7.56 6.13a9.2 9.2 0 01-5.68 0c-2.1-.68-3.92-2.5-7.56-6.13l-15-14.98C2.94 38.7 1.12 36.88.44 34.79a9.17 9.17 0 010-5.68c.68-2.1 2.5-3.9 6.14-7.54L21.6 6.58z",
  fill: "#FFAB00"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.38 30.62A18.62 18.62 0 0032 47.92a18.7 18.7 0 0018.62-17.3H46.6A14.63 14.63 0 0132 43.93a14.69 14.69 0 01-14.6-13.31h-4.02z",
  fill: "#DA771B"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "BusbudPanel_svg__clip0"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
}))));
var _default = exports.default = SvgComponent;